// reducers/contactUsReducer.js
const initialState = {
  loading: false,
  success: false,
  error: null,
};

export const contactUsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONTACT_US_REQUEST":
      return { loading: true, success: false, error: null };
    case "CONTACT_US_SUCCESS":
      return { loading: false, success: true, error: null };
    case "CONTACT_US_FAIL":
      return { loading: false, success: false, error: action.payload };
    case "CONTACT_US_RESET":   // ✅ clear state
      return initialState;
    default:
      return state;
  }
};
